"use client";

// src/components/Accordion/Chevron.tsx
import { jsx } from "react/jsx-runtime";
var ChevronRight = ({
  ...props
}) => {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "#20252A",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.4 3.20006C9.84183 2.86869 10.4686 2.95823 10.8 3.40006L16.8 11.4001C17.0667 11.7556 17.0667 12.2445 16.8 12.6001L10.8 20.6001C10.4686 21.0419 9.84183 21.1314 9.4 20.8001C8.95817 20.4687 8.86863 19.8419 9.2 19.4001L14.75 12.0001L9.2 4.60006C8.86863 4.15823 8.95817 3.53143 9.4 3.20006Z"
        }
      )
    }
  );
};
var Chevron_default = ChevronRight;

export {
  Chevron_default
};
